

module.exports = __webpack_require__.stylable.create(
    "Counter503621401",
    {"classes":{"root":"Counter503621401__root","btn":"Counter503621401__btn","inputWrapper":"Counter503621401__inputWrapper"},"vars":{},"stVars":{"DefaultColor":"color-5","DefaultDisabledColor":"color-3","DefaultErrorColor":"#f64d43","DefaultBackgroundColor":"color-1","DefaultWidth":"104px","MainColor":"--overridable","DisabledColor":"--overridable","MainWidth":"--overridable","counterColor":"\"color(fallback(--overridable, color-5))\"","counterDisabledColor":"\"color(fallback(--overridable, color-3))\"","counterWidth":"\"fallback(--overridable, 104px)\""},"keyframes":{}},
    "",
    8,
    "Counter503621401",
    null
);
